<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">Andrew Ireland was born in Birmingham in 1964, and moved to Cheshire a year before the new millennium. Recently retired, he spent over forty years working in food retail, with the past twenty-five years living with his wife, Tricia, and their two children, James and Bethany.</p>
<p style="text-indent:00em; padding-top:15px;">His hobbies include playing chess on a daily basis and training for his annual effort at the Blenheim Triathlon.</p>
<p style="text-indent:00em; padding-top:15px;">His love for Victorian literature began in his mid-twenties, and <em>Unwelcome Legacies</em> is influenced by both that and Tricia’s holiday fiction, which he reads on the beach in the South of France.</p>
<p style="text-indent:00em; padding-top:15px;">His favourite author is probably Anne Bronte, his favourite beer is definitely Timothy Taylor’s Golden Best.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4f423d67